import { Fragment } from "react";

import ReleaseNotesData from "../Helper/ReleaseNotesData";
import { styles } from './util';

const ReleaseNotes = ({ type }) => {
  const releaseData = ReleaseNotesData(type);

  if (!releaseData.length) {
    return null;
  }

  return (
    <div style={styles.notes}>
      {releaseData.map(({ component, notes }, index) => {
        // Getting a list of all the release notes issue type and
        // filtering out any null values from the release notes.
        // We also want to determine if the issue type is a 'Bug' or 'Story' for Component names.
        const issueTypeList = notes.map(({ IssueType }) => IssueType);
        const releaseNotesList = notes
          .map(({ ReleaseNotes }) => ReleaseNotes)
          .filter((x) => x !== null);
        const isComponent = issueTypeList.includes(type) && releaseNotesList.length > 0;

        return (
          <Fragment key={index}>
            {isComponent && <h3 style={styles.component}>{component}</h3>}
            {notes
              .filter(({ IssueType }) => IssueType.includes(type))
              .map(({ ReleaseNotes }, i) => (
                <Fragment key={i}>
                  {ReleaseNotes && (
                    <ul key={i}>
                      <li key={i}>{ReleaseNotes.replace("*****", "")}</li>
                    </ul>
                  )}
                </Fragment>
              ))}
          </Fragment>
        );
      })}
    </div>
  );
};

export default ReleaseNotes;
